import { Observable } from "rxjs";
import { generalTransaccionResponse } from "src/app/shared/domain/shared.request";
import { PRI_ActivarDesactivarTarifaRequest, PRI_ListarTarifaPorTipoServicioRequest, PRI_MantenimientoTarifaRequest, PRI_ObtenerProfitMinimoRequest, getDetailZonaRutaRequest, getTarifasEspecialesRequest, listarauditoriaRequest, managementTarifaEspecialRequest } from "../tarifario-sli/domain/tarifario-sli.request";

export abstract class PricingRepository {

    //#region TARIFARIO SLI

    // abstract setTariff(): Observable<generalTransaccionResponse>
    abstract PRI_ListarTarifaPorTipoServicio(request: PRI_ListarTarifaPorTipoServicioRequest): Observable<any>
    abstract PRI_ObtenerProfitMinimo(request: PRI_ObtenerProfitMinimoRequest): Observable<any>
    abstract PRI_MantenimientoTarifa(request: PRI_MantenimientoTarifaRequest): Observable<any>
    abstract PRI_ActivarDesactivarTarifa(request: PRI_ActivarDesactivarTarifaRequest): Observable<any>

    abstract managementTarifaEspecial(request: managementTarifaEspecialRequest): Observable<generalTransaccionResponse>
    abstract getTarifasEspeciales(request: getTarifasEspecialesRequest): Observable<any>
    //#endregion

    abstract getDetailZonaRuta(request: getDetailZonaRutaRequest): Observable<any>


     abstract listarauditoria(request: listarauditoriaRequest): Observable<any>




}